import type { CSSProperties } from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { WAITLIST_PAGE } from '../../data/waitlistPage';
import { SiteButton } from '../site/SiteButton';
import { WaitlistForm } from './WaitlistForm';

export function WaitlistShowcase() {
  const { hero, sidebar, cta } = WAITLIST_PAGE;
  const { ref: mainRef, visible: mainVisible } = useScrollReveal<HTMLElement>(0.12);
  const { ref: ctaRef, visible: ctaVisible } = useScrollReveal<HTMLElement>(0.18);

  return (
    <div className="waitlist-showcase">
      <section className="waitlist-hero">
        <div className="container">
          <div className="waitlist-hero__inner">
            <span className="waitlist-hero__tag">{hero.tag}</span>
            <h1 className="waitlist-hero__title">{hero.title}</h1>
            <p className="waitlist-hero__subtitle paragraph-02 text-dark-grey-two">{hero.subtitle}</p>
            <div className="waitlist-hero__chips">
              {hero.chips.map((chip) => (
                <span key={chip} className="waitlist-hero__chip">
                  {chip}
                </span>
              ))}
            </div>
          </div>

          <div className="waitlist-hero__orbit" aria-hidden>
            {[0, 1, 2, 3].map((i) => (
              <span
                key={i}
                className="waitlist-hero__orbit-dot"
                style={{ '--orbit-i': i } as CSSProperties}
              />
            ))}
          </div>
        </div>
      </section>

      <section ref={mainRef} className={`waitlist-main${mainVisible ? ' is-visible' : ''}`}>
        <div className="container waitlist-main__container">
          <WaitlistForm />

          <div className="waitlist-benefits reveal-item">
            <div className="waitlist-benefits__stat">
              <span className="waitlist-benefits__stat-value">
                {sidebar.stat.prefix}
                {sidebar.stat.value}
                {sidebar.stat.suffix}
              </span>
              <span className="waitlist-benefits__stat-label">{sidebar.stat.label}</span>
            </div>

            <ul className="waitlist-benefits__list">
              {sidebar.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>

            <div className="waitlist-benefits__note">
              <p className="waitlist-benefits__note-kicker">What happens next</p>
              <p className="waitlist-benefits__note-copy">
                We will email you when Hello Gwiji opens early access. Your interest selection helps
                us tailor your onboarding.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section ref={ctaRef} className={`waitlist-cta${ctaVisible ? ' is-visible' : ''}`}>
        <div className="container">
          <div className="waitlist-cta__card reveal-item">
            <h2>{cta.title}</h2>
            <p className="paragraph-02">{cta.description}</p>
            <SiteButton href={cta.href} variant="cta">
              {cta.button}
            </SiteButton>
          </div>
        </div>
      </section>
    </div>
  );
}
